import {createSlice} from '@reduxjs/toolkit';
import {FileListItemLayout} from 'interface/stacks/FileListItem';
import * as reducers from './reducers';
import * as selectors from './selectors';
import type {Store} from './types';

const initialState: Store = {
  root: {id: '', name: ''},
  sort: {category: 'name', order: 'asc'},
  filter: {type: 'all'},
  items: {},
  layout: FileListItemLayout.ListNormal,
  views: {},
  selection: [],
}

export default createSlice({name: 'files', reducers, initialState});
export {selectors};
